export default {
  protocol: {
    PCS108: "我同意并阅读",
    PCS109: "《数据处理协议》",
    PCS110: "《个人信息保护及隐私政策》",
    PCS111: "NuTag 用户协议",
    PCS112: "请阅读并勾选协议",
    PCS113: "和",
  },

  data: {
    private_agree: `个人信息保护及隐私政策`,
    private_agree_text: `
        <p><span style="font-size: 14px;"> 本政策仅适用于Nutag产品或服务。</span></p>
    <p><span style="font-size: 14px;"> 最近更新日期：2024年10月。</span></p>
    <p><span style="font-size: 14px;"> 如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</span></p>
    <p><span style="font-size: 14px;"> 电子邮箱：support@zkdigimax.com。</span></p>
    <p style="margin-top: 30px;"><span style="font-size: 14px;"> 本政策将帮助您了解以下内容：</span></p>

    <p style="margin-top: 30px;"><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">个人信息收集使用规则</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">我们如何保护您的个人信息</span>
    </p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">您的权利</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">我们如何处理未成年人的个人信息</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">本政策如何更新</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
          margin-right: 15px; "></span><span style="font-size: 14px;">如何联系我们</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">厦门熵基科技有限公司及其关联公司（下称“熵基科技”、“本公司”或“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，熵基科技承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">在使用本产品（或服务）前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用本产品或服务，即表示您已充分理解并同意本政策。</span></p>
    <p style="margin-top: 35px;"><strong><span style="font-size: 14px;">一、个人信息收集使用规则</span></strong></p>
    <p style="margin-top: 20px;"><strong><span style="font-size: 14px;">
        （一）我们收集哪些您的个人信息</span></strong></p>
    <p style="margin-top: 20px; text-indent: 2em"><span style="font-size: 14px;">1、您使用Nutag（软件产品名称），我们将收集您的以下信息：</span></p>


    <p style="text-indent: 2em"><span style="font-size: 14px;">我们提供的业务功能需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：用户名（姓名/昵称/别名/代码）、电话号码、邮箱。</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">根据您选择的软件产品，您可选择性录入手机号/姓名，在账号登录需要使用邮箱作为账号，您必须提供真实邮箱才能使用相关业务</span></p>
    <p style="margin-top: 20px; text-indent: 2em"><span style="font-size: 14px;">2、您可自主选择向我们提供或允许我们收集下列信息：个人照片、居住地址、公司、IP地址信息、MAC地址信息、访问日期和时间。</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">这些信息并非该业务功能运行所必需，但这些信息对改善服务质量、研发新产品或服务等有非常重要的意义。我们不会强制要求您提供这些信息，您如拒绝不会对使用该业务功能产生不利影响</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">3、在您使用该业务功能时，我们的软件会向您申请下列与个人信息相关的系统权限：获取定位。</span>
    </p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">如果您不授权，将会导致我们无法提供该业务功能。除上述权限之外，您可自主选择是否额外授予软件其他的系统权限。</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span></p>

    <p><strong><span style="font-size: 14px;">（二）我们如何使用您的个人信息</span></strong></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">1、对于必要的个人信息，我们会用来提供该项业务功能，我们也会使用以下信息来维护和改进本项业务功能，开发新的业务功能等。</span></p>
    <table style="width: auto; border-collapse: collapse;  margin: 0 auto;">
        <tbody>
            <tr>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    信息类型
                </td>

                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    使用目的
                </td>

                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    保存期限
                </td>
            </tr>

            <tr>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    用户名（姓名/昵称/别名/代码）、电话号码、邮箱
                </td>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    记录账号信息
                </td>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    永久（账户注销即删除
                </td>
            </tr>
        </tbody>
    </table>


    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">（三）我们如何使用Cookie和同类技术</span></strong>
    </p>

    <p>
        <span style="font-size: 14px">1. Cookies</span>
    </p>
    <p style="text-indent: 2em">
        <span style="font-size: 14px">Cookie和同类技术是互联网中普遍使用的技术。为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。我们不会将Cookie用于本政策所述目的之外的任何目的。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</span>
    </p>
    <p>
        <span style="font-size: 14px">2. 其他同类技术</span>
    </p>

    <p style="text-indent: 2em">
        <span style="font-size: 14px">除Cookie外，我们还会在网站上使用网站信标、像素标签等其他同类技术，帮助我们了解您的产品或服务偏好并改善客户服务。</span>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px"></span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px"></span></strong>
    </p>

    <p>
        <strong><span style="font-size: 14px">（四）云平台安全责任</span></strong>
    </p>

    <p style="text-indent: 2em">
        <span style="font-size: 14px">1、熵基负责熵基云平台上的服务和数据交互的安全管理和运营，对提供的云服务平台和基础架构的安全性负责。客户通过调用API接口、SDK自行开发的软件或硬件嵌入式软件，接入熵基云平台需要客户自己保障其应用及数据，包括硬件设备、软件的安全合规。其中熵基云的主要责任是研发并运维各项基础服务、平台服务和应用服务，而客户的主要责任是在使用熵基云服务之上定制开发的第三方客户端和搭建的第三方云服务等。下图为基础云服务提供商、熵基以及客户信息安全责任共同承担责任模型。</span>
    </p>

        <table style="width: 100%; height: 100vh; border-collapse: collapse">
      <tr>
        <th
          rowspan="11"
          style="
            border: 1px solid black;
            text-align: center;
            writing-mode: vertical-rl;
            background-color: #f4f4f4;
            height: 100vh;
          "
        >
          安全运营管理
        </th>
        <th
          colspan="3"
          style="
            border: 1px solid black;
            text-align: center;
            background-color: #f4f4f4;
          "
        >
          熔基云平台、软件、嵌入式软件
        </th>
        <th
          rowspan="12"
          style="
            border: 1px solid black;
            text-align: center;
            writing-mode: vertical-rl;
            background-color: #f4f4f4;
            height: 100vh;
          "
        >
          认证&nbsp;&nbsp; / 访问控制&nbsp;&nbsp; / 权限控制
        </th>
      </tr>

      <!-- 第二行，六个单元格分为两行三列 -->
      <tr>
        <td style="border: 1px solid black; text-align: center">
          第三方客户端
        </td>
        <td style="border: 1px solid black; text-align: center">
          硬件 / 嵌入式软件
        </td>
        <td style="border: 1px solid black; text-align: center">第三方云</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; text-align: center">API / SDK</td>
        <td style="border: 1px solid black; text-align: center">模组 / SDK</td>
        <td style="border: 1px solid black; text-align: center">API / SDK</td>
      </tr>

      <!-- 第三行，背景高亮的行 -->
      <tr style="background-color: #e9f5e9">
        <td colspan="3" style="border: 1px solid black; text-align: center">
          熔基云
        </td>
      </tr>
      <!-- 第四行 -->
      <tr>
        <td style="border: 1px solid black; text-align: center">
          管理身份校验
        </td>
        <td style="border: 1px solid black; text-align: center">管理出入口</td>
        <td style="border: 1px solid black; text-align: center">管理办公</td>
      </tr>
      <!-- 第五行，背景高亮的行 -->
      <tr style="background-color: #e9f5e9">
        <td colspan="3" style="border: 1px solid black; text-align: center">
          数据服务
        </td>
      </tr>
      <!-- 第六行 -->
      <tr>
        <td style="border: 1px solid black; text-align: center">存储</td>
        <td style="border: 1px solid black; text-align: center">数据库</td>
        <td style="border: 1px solid black; text-align: center">数据隔离</td>
      </tr>
      <!-- 第七行 -->
      <tr>
        <td style="border: 1px solid black; text-align: center">日志服务</td>
        <td style="border: 1px solid black; text-align: center">数据分析</td>
        <td style="border: 1px solid black; text-align: center"></td>
      </tr>
      <!-- 第八行，背景高亮的行 -->
      <tr style="background-color: #e9f5e9">
        <td colspan="3" style="border: 1px solid black; text-align: center">
          基础设施
        </td>
      </tr>
      <!-- 第九行 -->
      <tr>
        <td style="border: 1px solid black; text-align: center">腾讯云</td>
        <td style="border: 1px solid black; text-align: center">AWS</td>
        <td style="border: 1px solid black; text-align: center">阿里云</td>
      </tr>
      <!-- 第十行，背景高亮的行 -->
      <tr style="background-color: #e9f5e9; border: 1px solid black">
        <td style="border: 1px solid black; text-align: center">
          熔基与基础设施提供共享责任
        </td>
        <td style="border: 1px solid black; text-align: center">熔基云责任</td>
        <td style="border: 1px solid black; text-align: center">客户责任</td>
      </tr>
    </table>
   
   
    <p style="text-indent: 2em">
        <span style="font-size: 14px">2、熵基云的安全责任</span>
    </p>
    <p>
        <span style="font-size: 14px">a) &nbsp;&nbsp;熵基云通过选择全球知名的云主机服务商亚马逊、腾讯云、阿里云等一流云计算平台，确保安全管理和运营的基础设施，物理设备的安全。</span>
    </p>

    <p>
        <span style="font-size: 14px">b) &nbsp;&nbsp;熵基云安全覆盖数据安全和云服务安全。熵基承诺利用其安全团队以及全球范围知名的安全服务厂商的专业攻击防护技术经验，提供云平台的安全运维和运营服务，切实保护熵基云的安全运营，以及保障客户、用户隐私和数据的安全。包括但不限于：</span>
    </p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">数据安全：指客户在云业务环境中的业务数据自身的安全管理，包括收集与识别、分类与分级、权限与加密以及隐私合规等方面；</span></p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">访问控制管理：对资源和数据的访问权限管理，包括用户管理、权限管理、身份验证等；</span></p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">云服务安全：指在云计算环境下的业务相关应用系统的安全管理，包括应用和服务接口的设计、开发、发布、配置和使用等方面。</span></p>

    <p style="text-indent: 2em">
        <span style="font-size: 14px">3、客户的安全责任</span>
    </p>
    <p><span style="font-size: 14px">a) &nbsp;&nbsp;客户在使用熵基云的解决方案的时候，需要严格按照熵基的安全配置和接入要求执行。同时客户需要保证自己的云端、客户端或者硬件产品本身的安全性。</span></p>
    <p><span style="font-size: 14px">b) &nbsp;&nbsp;基于熵基SDK/API开发的应用软件，熵基仅提供技术支持，但是无法为该软件整体提供安全保障。</span>
    </p>
    <p><span style="font-size: 14px">c) &nbsp;&nbsp;对于基于熵基方案的定制产品的数据安全合规、隐私政策等相关信息，隐私政策声明以及法律合规性由客户负责，必要时候，熵基安全合规团队愿意提供安全解决方案的帮助和咨询服务。</span></p>
    <p><span style="font-size: 14px"></span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">（五）我们如何共享、转让、公开披露您的个人信息</span></strong>
    </p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">1. 共享</span></strong>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px">我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
        </span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">2. 转让</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span></p>
    <p><span style="font-size: 14px">a) &nbsp;&nbsp;在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span></p>
    <p><span style="font-size: 14px">b) &nbsp;&nbsp;在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">3. 公开披露</span></strong>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px">我们仅会在以下情况下，公开披露您的个人信息：</span></p>
    <p><span style="font-size: 14px">c) &nbsp;&nbsp;获得您明确同意后；</span></p>
    <p><span style="font-size: 14px">d) &nbsp;&nbsp;基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息</span></p>
    <p><strong><span style="font-size: 14px">包括：</span></strong></p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px;margin-left: 15px;">与个人信息控制者履行法律法规规定的义务相关的；</span>
    </p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px; margin-left: 15px;">与国家安全、国防安全直接相关的</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px; margin-left: 15px;">与公共安全、公共卫生、重大公共利益直接相关的；</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px; margin-left: 15px;">与刑事侦查、起诉、审判和判决执行等直接相关的；</span>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px; margin-left: 15px;">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</span>
        </p>


        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">所涉及的个人信息是个人信息主体自行向社会公众公开的；</span>
        </p>


        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">根据个人信息主体要求签订和履行合同所必需的；</span>
        </p>


        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
        </p>


        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</span>
        </p>


        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；</span>
        </p>

        <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
        <span style="font-size: 14px; margin-left: 15px;">个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要， 且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</span>
        </p>
        <p style="margin-top: 25px;text-indent: 2em">
            <span style="font-size: 14px">请您注意，根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
        </p>

        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px">二、我们如何保护您的个人信息</span></strong>
        </p>

        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">（一）我们重视个人数据的安全。我们采用适当的物理、管理和技术保障措施来保护您的个人数据不被未经授权访问、披露、使用、修改、损坏或丢失。例如，我们会使用加密技术确保数据的机密性；我们会使用保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人数据；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人数据重要性的认识。我们会尽力保护您的个人数据，但是请注意任何安全措施都无法做到无懈可击。</span></p>
        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">（二）我们将会在达成本政策所述目的所需的期限内保留您的个人数据，除非按照法律要求或许可需要延长保留期或受到法律的允许。因为基于不同的场景和产品及服务的不同，数据的存储期可能会有所不同，我们用于确定存留期的标准包括：完成该业务目的需要留存个人数据的时间，包括提供产品和服务，维护相应的交易及业务记录，管控并提升产品与服务性能与质量，保证系统、产品和服务的安全，应对可能的用户查询或投诉，问题定位等；用户是否同意更长的留存期间；法律、合同等是否有保留数据的特殊要求等。只要您的账户是为您提供服务必须，我们都将保留您的注册信息。您也可以选择注销您的账号，在您注销账号后，我们会停止基于该账号提供产品和服务，并在无特殊法律要求的情况下，删除您相应的个人数据。</span></p>
        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px"> (三)在不幸发生个人信息安全事件后，我们将按照法律法规的要求（最迟不超过30个自然日内）向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span></p>
        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">（四）互联网环境并非百分之百安全，尽管我们有这些安全措施，但请注意在互联网上不存在“完善的安全措施”，我们将尽力确保您的信息的安全性。</span></p>
        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">（五）为确保流畅的浏览体验，您可能会收到来自我们及其合作伙伴外部的第三方（下文简称“第三方”）提供的内容或网络链接。我们对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。我们无法控制第三方的隐私和数据保护政策，此类第三方不受到本政策的约束。在向第三方提交个人信息之前，请参见该第三方的隐私保护政策。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px"></span></p>
        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px"></span></strong>
        </p>


        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px">三、您的权利</span></strong>
        </p>
        <p style="text-indent: 2em"><span style="font-size: 14px">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span></p>
        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px">(一) &nbsp;&nbsp;访问您的个人信息</span></strong>
        </p>
        <p style="text-indent: 2em"><span style="font-size: 14px">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：登入软件平台可以查看个人信息</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">如果您无法通过上述链接访问这些个人信息，您可以随时发送电子邮箱至Support@zkdigimax.com</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请发送电子邮箱至Support@zkdigimax.com</span></p>


        <p><strong><span style="font-size: 14px">(二) 更正您的个人信息</span></strong>
        <p style="text-indent: 2em"><span style="font-size: 14px">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。</span>
        <p style="text-indent: 2em"><span style="font-size: 14px">如果您无法通过上述链接更正这些个人信息，您可以随时发送电子邮箱至Support@zkdigimax.com</span>
        </p>
        <strong><span style="font-size: 14px">(三) &nbsp;&nbsp;删除您的个人信息</span></strong>
        </p>
        <p style="text-indent: 2em"><span style="font-size: 14px">在以下情形中，您可以向我们书面提出删除个人信息的请求：</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">1、如果我们处理个人信息的行为违反法律法规；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">2、如果我们收集、使用您的个人信息，却未征得您的同意；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">3、如果我们处理个人信息的行为违反了与您的约定；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">4、如果您不再使用我们的产品或服务，或您注销了账号；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">5、如果我们不再为您提供产品或服务。</span></p>
        <p style="text-indent: 2em; margin-top: 25px;"><span style="font-size: 14px">当适用的法律要求的情况下，当我们基于您的同意处理您的个人数据时，您还有权随时撤销您的同意。但撤销同意不会影响撤销前我们基于您的同意处理您个人数据的合法性及效力，也不影响我们基于其他适当的正当性基础处理您的个人数据。</span></p>



        <p style="margin-top: 25px">
            <strong><span style="font-size: 14px">(四) &nbsp;&nbsp;响应您的上述请求</span></strong>
        </p>

        <p style="text-indent: 2em"><span style="font-size: 14px">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">我们将在 7天内作出答复。如您不满意，还可以通过以下途径投诉：Support@zkdigimax.com</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">在以下情形中，我们将无法响应您的请求：</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">1、与个人信息控制者履行法律法规规定的义务相关的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">2、与国家安全、国防安全直接相关的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">3、与公共安全、公共卫生、重大公共利益直接相关的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">4、与刑事侦查、起诉、审判和执行判决等直接相关的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">5、个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的； </span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">8、涉及商业秘密的。</span></p>

        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px"></span>四、我们如何处理未成年人的个人信息?</strong>
        </p>

        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不应创建自己的个人信息主体账户。如您为未成年人的，建议您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</span></p>

        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px">五、本政策如何更新</span></strong>
        </p>

        <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">我们的个人信息保护及隐私政策可能变更。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮箱发送通知，说明个人信息保护政策的具体变更内容）。</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">本政策所指的重大变更包括但不限于：</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">3、个人信息共享、转让或公开披露的主要对象发生变化；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span></p>
        <p style="text-indent: 2em"><span style="font-size: 14px">我们还会将本政策的旧版本存档，供您查阅。</span></p>
        <p style="margin-top: 35px">
            <strong><span style="font-size: 14px">六、如何联系我们</span></strong>
        </p>
        <p style="text-indent: 2em"><span style="font-size: 14px">如果您对本个人信息保护及隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：将您的问题发送至Support@zkdigimax.com。一般情况下，我们将在7天内回复。更多联系方式会在我们的官方网站（http://www.zkteco.com）上公告。</span></p>

       `,

    user_agree: "数据处理协议",
    user_agree_text: `<p style="text-align: center"><strong>数据处理协议</strong></p>
    <p>版本号 :<span> V2.0</span></p>
    <p>日期 :<span> 2024年10月</span></p>
    <p><span>前言</span></p>
    <p><span>欢迎使用Nutag软件及服务！</span></p>
    <p style="text-indent: 2em; margin-top: 30px">
      <span
        >熵基科技深知个人数据对您的重要性，并会尽全力保护您的个人数据安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人数据：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，熵基科技承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人数据。</span
      >
    </p>
    <p style="text-indent: 2em; margin-top: 10px">
      <span
        >请用户务必审慎阅读、充分理解各条款内容。除非用户已阅读并接受本协议所有条款，否则用户无权下载、安装或使用本软件及相关服务。用户的下载、安装、使用Nutag软件、登录账号等行为即视为用户已阅读并同意本协议的约束。</span
      >
    </p>
    <p style="margin-top: 20px">
      <span> 一、协议适用范围</span>
    </p>
    <p style="text-indent: 2em; margin-top: 20px">
      <span
        >本协议是用户与熵基科技之间关于用户下载、安装、使用本软件，以及使用熵基科技相关服务所订立的协议。“熵基科技”是指厦门熵基科技有限公司及其相关服务可能存在的运营关联单位，在本协议中称为“我们”。“用户”是指注册、登录、使用本软件及服务并获得管理权限的个人或组织，在本协议中称为“您”。</span
      >
    </p>

    <p style="margin-top: 20px"><span>二、数据处理范围</span></p>
    <p style="text-indent: 2em; margin-top: 10px">
      <span
        >在我们向您提供相关服务过程中，会涉及个人数据收集，详见下表所列信息。</span
      >
    </p>
    <table style="width: auto; border-collapse: collapse; margin: 0 auto">
      <tbody>
        <tr>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            业务场景
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            业务活动
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="245"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            数据清单
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="245"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            数据主体类别
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="245"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            涉及的数据处理活动及使用目的
          </td>
        </tr>

        <tr>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            我们提供远程技术支持给用户
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            我们在软件实施、运维过程中可能会接触用户的个人数据
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            用户名（姓名/昵称/别名/代码）、电话号码、邮箱、账号密码
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            用户
          </td>
          <td
            colspan="1"
            rowspan="1"
            width="182"
            style="
              border: 1px solid black;
              padding: 8px;
              text-align: left;
              text-align: center;
            "
          >
            涉及到个人数据的存储、分析、删除；用于业务信息展示及分析，包括展示、更新、数据维护、个人标记、安全追溯、业务要求、研究、基本维护、账号管理
          </td>
        </tr>
      </tbody>
    </table>
    <p><span>三、定义</span></p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >除非双方另有约定，本协议中使用的术语定义按英文首字母顺序排列如下。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（一）“数据主体”（Data
        Subject），是指已确认身份或可确定身份的自然人。可确定身份的自然人是指可直接或间接确定身份的个人，特别是通过参考身份标识确定身份，身份标识包括姓名、身份证号、位置数据、在线身份标识或特定于该自然人的身体、生理、基因、精神、经济、文化或社会身份的一个或多个因素等。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（二）“欧盟标准合同条款”（EU Standard Contractual
        Clauses）是指自欧盟法案2016年第79号第44条起（且根据欧盟指令95/46/EC第26(2)条）规定的，向成立于无法确保充分数据保护的第三方国家/地区的处理方传输个人数据的相关标准合同条款，这些条款已在欧盟委员会相关网站上发布，可能随时修改或更新。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（三）“个人数据”（Personal
        Data）是指与已确认身份或可确定身份的自然人（“数据主体”）有关的任何信息。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（四）“个人数据泄露”（Personal Data
        Breach）是指按照本地数据保护法规规定，包括但不限于意外或非法销毁、丢失、更改、未经授权披露或访问传输、存储或其他方式处理的个人数据的安全违规行为。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（五）“数据保护法规”（Privacy
        Laws）是指与个人数据的安全和保护有关的任何可能适用的法律和/或条例（如GDPR或其他国家可适用的隐私保护法律），根据其实施或制定的任何法律和条例，以及这些法律和条例的修订、更新或重新颁布版本。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（六）“监管机构”（Regulatory
        Bodies）是指有权根据法令、规则、条例、行为准则或其他文件进行监管、调查或影响与数据安全和个人数据及隐私保护有关事宜的政府部门、监管机构、法定机构和其它机构。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（七）“服务”（Service）是指熵基科技根据与用户订立的具体服务协议及其他合同文本提供的涉及处理个人数据的服务。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（八）“子处理者”（Sub-processor），指熵基科技及相关团体以外的涉及个人信息处理的组织或个人。</span
      >
    </p>
    <p><span>四、数据处理要求</span></p>
    <p style="margin-top: 20px">
      <span>（一）数据处理原则</span>
    </p>

    <p style="text-indent: 2em; margin-top: 10px">
      <span style="text-indent: 18pt"
        >我们按照“合法、正当、透明、目的限制、数据最小化、准确、存储期限最小化、完整性与保密性、可问责”的通用原则进行个人数据处理，我们将按照您的指示开展数据处理活动，不能超出您的指示以及本协议约定的目的和范围，不得将个人数据用于任何其他目的。我们认为您的指示违反适用的数据保护法规时，我们将立即通知您。我们将全力支持您保护数据主体的权利，如访问、更正、删除。
      </span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt; margin-top: 10px"
        >我们将以云服务提供商提供的时钟源配置为准，若我们产品的服务方式/服务内容发生变更，将第一时间邮件周知您。</span
      >
    </p>
    <p style="margin-top: 20px">
      <span>（二）特殊类别的个人数据处理</span>
    </p>
    <p style="text-indent: 2em; margin-top: 10px">
      <span style="text-indent: 18pt; margin-top: 10px"
        >我们不会以违反适用的数据保护法规的方式处理可能揭示种族或民族起源、政治观点，或行业工会成员资格的任何个人数据，唯一能识别自然人身份的生物数据。</span
      >
    </p>

    <p style="margin-top: 20px">
      <span>（三）个人数据跨境转移</span>
    </p>
    <p style="text-indent: 2em; margin-top: 10px">
      <span style="text-indent: 18pt">不涉及个人数据跨境处理。</span>
    </p>
    <p style="margin-top: 20px">
      <span>（四）数据安全</span>
    </p>
    <p style="text-indent: 2em; margin-top: 20px">
      <span style="text-indent: 18pt; margin-top: 20px"
        >在处理个人数据期间，我们根据适用的数据保护法规及您的要求采取有效的技术和组织措施，保证在数据处理过程中对可能接触的个人数据采取不低于自身信息保密程度的保密措施进行保密，未经您的书面许可，不得向任何第三方披露，保护个人数据免遭泄露。</span
      >
    </p>
    <p style="margin-top: 20px">
      <span>（五）数据泄露事故应急机制</span>
    </p>

    <p style="text-indent: 2em; margin-top: 10px">
      <span style="text-indent: 18pt"
        >1、在发现个人数据泄露事件后，我们会在七十二（72）小时内向您发送书面通知，以履行根据适用的数据保护法规规定通知监管机构和数据主体的义务。此类通知包含如下内容：:</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（1）概述个人数据泄露的影响，包括但不限于描述个人数据泄露的性质、相关数据主体的类别和数量以及相关个人数据处理记录。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（2）个人数据泄露可能造成的风险和后果。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（3）我们为处理个人数据泄露而采取的措施或提出的建议。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（4）我们的数据保护官、隐私保护官及任何能提供详细信息的相关联系人的姓名和联系方式。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（5）您合理要求的与个人数据泄露相关的任何其他信息。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（6）如果上述信息不能在同一时间提供，则应在三十六（36）小时或者是在您要求的时间内分阶段提供。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >2、对于任何发生的个人数据泄露，我们将立即调查，识别、防止并降低影响，并在您事先同意的情况下，采取必要的补救措施。</span
      >
    </p>
    <p style="margin-top: 20px">
      <span>（六）子处理者引入</span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >1、未经您的允许，我们不会将任何个人数据处理业务转包或外包给子处理者。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >2、根据适用的法律要求，我们应和子处理者签订数据处理协议并做尽职调查。我们将向子处理者传递您的要求，并对子处理者或其指定的任何第三方的数据处理行为导致的负面影响或不利后果承担责任。</span
      >
    </p>

    <p style="margin-top: 20px"><span>（七）个人数据的删除</span></p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >除非有相反要求或数据保护法规另有规定，根据您的要求，一旦履行完双方之间适用的协议中约定的我们的义务，我们会立即删除相关个人数据，并向您证明其已经履行该义务。</span
      >
    </p>
    <p style="margin-top: 20px">
      <span>（八）云平台安全责任</span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >1、熵基负责熵基云平台上的服务和数据交互的安全管理和运营，对提供的云服务平台和基础架构的安全性负责。客户通过调用API接口、SDK自行开发的软件或硬件嵌入式软件，接入熵基云平台需要客户自己保障其应用及数据，包括硬件设备、软件的安全合规。其中熵基云的主要责任是研发并运维各项基础服务、平台服务和应用服务，而客户的主要责任是在使用熵基云服务之上定制开发的第三方客户端和搭建的第三方云服务等。下图为基础云服务提供商、熵基以及客户信息安全责任共同承担责任模型。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span>2、熵基云的安全责任</span>
    </p>

    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（1）熵基云通过选择全球知名的云主机服务商亚马逊、腾讯云、阿里云等一流云计算平台，确保安全管理和运营的基础设施，物理设备的安全。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（2）熵基云安全覆盖数据安全和云服务安全。熵基承诺利用其安全团队以及全球范围知名的安全服务厂商的专业攻击防护技术经验，提供云平台的安全运维和运营服务，切实保护熵基云的安全运营，以及保障客户、用户隐私和数据的安全。包括但不限于：</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >a.
        数据安全：指客户在云业务环境中的业务数据自身的安全管理，包括收集与识别、分类与分级、权限与加密以及隐私合规等方面；</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >b.
        访问控制管理：对资源和数据的访问权限管理，包括用户管理、权限管理、身份验证等；</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >c.
        云服务安全：指在云计算环境下的业务相关应用系统的安全管理，包括应用和服务接口的设计、开发、发布、配置和使用等方面。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span>3、客户的安全责任</span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（1）客户在使用熵基云的解决方案的时候，需要严格按照熵基的安全配置和接入要求执行。同时客户需要保证自己的云端、客户端或者硬件产品本身的安全性。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（2）基于熵基SDK/API开发的应用软件，熵基仅提供技术支持，但是无法为该软件整体提供安全保障。</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >（3）对于基于熵基方案的定制产品的数据安全合规、隐私政策等相关信息，隐私政策声明以及法律合规性由客户负责，必要时候，熵基安全合规团队愿意提供安全解决方案的帮助和咨询服务。</span
      >
    </p>

    <p style="margin-top: 20px"><span>（九）数据备份</span></p>
    <p style="text-indent: 2em">
      <span
        >为防止数据因硬件故障、自然灾害等各种不可预见原因造成丢失，我们将定期备份云端数据库，并与（四）数据安全保持一致。备份频率为一天一备份，且备份数据加密存储，并在服务结束时在7天内依法删除您相关备份。</span
      >
    </p>
    <p style="margin-top: 20px"><span>五、责任</span></p>
    <p style="text-indent: 2em">
      <span
        >您作为数据控制者，必须对遵守适用的数据保护法规承担责任。您有义务评估存储在软件上的个人数据处理的合法性。您应确保向我们披露的任何个人数据披露均合法。
      </span>
    </p>
    <p style="margin-top: 20px"><span>六、审计权</span></p>
    <p style="text-indent: 2em">
      <span>您可以每年审核一次我们对协议条款和本数据处理协议的遵守情况。</span>
    </p>
    <p style="margin-top: 20px"><span>七、适用法律</span></p>
    <p style="text-indent: 2em">
      <span>本协议将受用户所在成员国的法律管辖。</span>
    </p>`,
  },
};
